import { render, staticRenderFns } from "./widget-template-card.vue?vue&type=template&id=3f514d3e&scoped=true&"
import script from "./widget-template-card.vue?vue&type=script&lang=js&"
export * from "./widget-template-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f514d3e",
  null
  
)

export default component.exports